function fn_comp_contacts() {
    var $fn = $(".comp_contacts");

    if($fn.length){
        var $map = $fn.find(".elm_map"),
            $streetview = $fn.find(".elm_streetview");

        function fn_part_filter_map() {
            $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCyz1X9wcuSt-RRCDCvAypsZOSj7-hoOQc")
                .done(function () {
                    $map.nl_google_map('init');
                    $map.nl_google_map('markers_add');
                    $map.nl_google_map("marker_click",0);
                    $streetview.nl_google_map("streetview");
                });
        }
        fn_part_filter_map();
    }
}